var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHtml5V2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97.886,
    height: 111,
    viewBox: "0 0 97.886 111",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #e44d26;\n      }\n\n      .cls-2 {\n        fill: #f16529;\n      }\n\n      .cls-3 {\n        fill: #ebebeb;\n      }\n\n      .cls-4 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6646",
    "data-name": "Group 6646",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13513",
    "data-name": "Path 13513",
    className: "cls-1",
    d: "M0,0,8.9,99.937,48.862,111,88.984,99.884,97.886,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13514",
    "data-name": "Path 13514",
    className: "cls-2",
    d: "M35.075,100.177V5.878H75.088L67.453,91.138",
    transform: "translate(13.868 2.324)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13515",
    "data-name": "Path 13515",
    className: "cls-3",
    d: "M13.033,14.638H43.791V26.887H26.469L27.6,39.433H43.791V51.655H16.378m.54,6.152h12.3l.864,9.794,13.707,3.67V84.06L18.645,77.045",
    transform: "translate(5.153 5.788)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13516",
    "data-name": "Path 13516",
    className: "cls-4",
    d: "M65.741,14.637h-30.7v12.25H64.608M63.5,39.433H35.037v12.25H50.146L48.716,67.6,35.037,71.27V84.006l25.092-6.962",
    transform: "translate(13.853 5.787)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml5V2);
export default __webpack_public_path__ + "static/media/html5v2.3158e3b3cbf026dd0c08660dcc1e96df.svg";
export { ForwardRef as ReactComponent };